var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83366 7.25008H2.41699V24.1667C2.41699 25.4959 3.50449 26.5834 4.83366 26.5834H21.7503V24.1667H4.83366V7.25008ZM24.167 2.41675H9.66699C8.33783 2.41675 7.25033 3.50425 7.25033 4.83341V19.3334C7.25033 20.6626 8.33783 21.7501 9.66699 21.7501H24.167C25.4962 21.7501 26.5837 20.6626 26.5837 19.3334V4.83341C26.5837 3.50425 25.4962 2.41675 24.167 2.41675ZM24.167 19.3334H9.66699V4.83341H24.167V19.3334ZM12.0837 10.8751H21.7503V13.2917H12.0837V10.8751ZM12.0837 14.5001H16.917V16.9167H12.0837V14.5001ZM12.0837 7.25008H21.7503V9.66675H12.0837V7.25008Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionNavIcon);
export default __webpack_public_path__ + "static/media/subscription_nav_icon.ae6ee386f2d064fe51509ea9f185afd4.svg";
export { ForwardRef as ReactComponent };